// delLists/approvalLists/state.js

export const approvalsInitialState = {
  items: [],
  tableType: "approvals",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedApproval: null,
};
